<template>
  <span></span>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';

export default {

  props: {
    expiresInSeconds: Number,
    accessToken: String,
    refreshToken: String,
    returnPath: String,
    redirectPath: String,
    apiSwitch: String,
  },

  computed: {
    tokenData() {
      const {
        expiresInSeconds,
        accessToken,
        refreshToken,
        returnPath,
        redirectPath,
        apiSwitch,
      } = this;

      return {
        expiresInSeconds,
        accessToken,
        refreshToken,
        returnPath,
        redirectPath,
        apiSwitch,
      };
    },
    isValid() {
      const {
        returnPath,
        redirectPath,
        redirectTo,
        apiSwitch,
        ...tokenData
      } = this.tokenData;

      return Object.values(tokenData).every(Boolean);
    },
  },

  async mounted() {
    if (this.isValid) {
      try {
        this.resetStore('auth');
        this.setToken(this.tokenData);

        if (this.tokenData?.apiSwitch && this.$apiSwitch) {
          this.$apiSwitch.selected = this.tokenData.apiSwitch;
        }

        this.$router.replace(this.getRedirectRoute('home'));

        return;
      } catch (e) {
        //
      }
    }

    this.$router.push(this.getRedirectRoute('login'));
  },

  methods: {
    ...mapMutations('auth', [
      'setToken',
    ]),
    ...mapActions([
      'resetStore',
    ]),
    getRedirectRoute(defaultRouteName) {
      if (this.tokenData?.redirectPath) {
        if (this.tokenData.redirectPath[0] === '/') {
          return {
            path: this.tokenData.redirectPath,
          };
        }

        if (this.tokenData.redirectPath[0] === '%') {
          return {
            path: decodeURIComponent(this.tokenData.redirectPath),
          };
        }

        return {
          name: this.tokenData.redirectPath,
        };
      }

      return {
        name: defaultRouteName,
      };
    },
  },
};
</script>
